import './DropdownMenu.css'
import DownArrow from '../svgs/map/DownArrow';

const colorDict={
    'Pending':'rgb(22,180,255)',
    'Testing':'orange',
    'Resolved':'rgb(47,255,208)',
    'Real Alert':'rgb(47,255,208)',
    'Unintended':'rgb(255, 74, 216)',
}
export const conditionColorDict= colorDict
export default function Component(props){
    const select=(item,index)=>()=>{
        if(props.select)props.select(item,index)
    }
    return(
        <div className='relative dropdown_main select-none cursor-pointer text-white'>
            <div className="hover:bg-[#888] flex flex-row items-center text-[12px] gap-[8px] px-[16px] py-[4px] rounded-[16px] border pointer-cursor justify-between" style={{width:props.isFullWidth?'100%':'auto',minWidth:props.minWidth||180,border:'.5px solid #ffffff80',color:props.showColor?(colorDict[props.value]||'white'):'white'}}> 
                {props.value}
                <DownArrow/>
            </div>
            <div className='absolute top-[100%] left-0 dropdown_main_expand flex-col text-xs bg-black w-full gap-[4px] rounded-[4px] border border-[#aaa] max-h-[200px]' style={{overflowY:'auto', zIndex:999}}>
                {(props.options||['Today','7 Days','30 Days','Select Date']).map((item,index)=>
                    <div key={index} onClick={select(item,index)} className='px-[16px] py-[4px] hover:text-black hover:bg-white cursor-pointer' style={{color:props.showColor?(colorDict[item]||'white'):'white'}}> {item}</div>
                )}
            </div>
        </div>
    )
}